import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import WordTranslationEmbed from '../components/Exercise/WordTranslationEmbed';

export default Node.create({
  name: 'wordTranslationExercise',
  group: 'block',
  atom: true,
  draggable: true,
  addAttributes() {
    return {
      pairs: { 
        default: [],
        parseHTML: element => {
          const data = element.getAttribute('pairs');
          if (data) {
            try {
              return JSON.parse(data);
            } catch (e) {
              console.error('Error parsing WordTranslation pairs from HTML:', e);
              return [];
            }
          }
          return [];
        },
        renderHTML: attributes => {
          if (attributes.pairs) {
            return {
              pairs: JSON.stringify(attributes.pairs)
            };
          }
          return {};
        }
      },
      title: { 
        default: 'Word-Translation Matching',
        parseHTML: element => element.getAttribute('title') || 'Word-Translation Matching',
        renderHTML: attributes => {
          if (attributes.title) {
            return {
              title: attributes.title
            };
          }
          return {};
        }
      },

      targetLanguage: {
        default: 'English',
        parseHTML: element => element.getAttribute('targetLanguage') || 'English',
        renderHTML: attributes => {
          if (attributes.targetLanguage) {
            return {
              targetLanguage: attributes.targetLanguage
            };
          }
          return {};
        }
      },
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {}
      }
    };
  },
  parseHTML() {
    return [
      { tag: 'div[data-type="word-translation-exercise"]' },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'word-translation-exercise' })];
  },
  addNodeView() {
    return ReactNodeViewRenderer(WordTranslationEmbed);
  },
  addCommands() {
    return {
      insertWordTranslationExercise:
        (attributes) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: attributes,
          });
        },
    };
  },
}); 